<template>
  <div class="create-temp">
    <el-form ref="formRef" :model="data" :rules="FormRules" label-width="80px" label-position="right" style="width: 650px;">
      <el-form-item label="模板名称" prop="title">
        <el-input v-model="data.title" placeholder="请输入模板名称" clearable disabled></el-input>
      </el-form-item>
      <el-form-item label="所属区域" class="temp-location" prop="province_id">
        <el-row :gutter="20" type="flex" justify="space-between">
          <el-col :span="12">
            <el-form-item prop="province_id">
              <el-select v-model="data.province_id" @change="provinceChange" placeholder="请选择省份">
                <el-option v-for="item in province" :label="item.name" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="city_id">
              <el-select v-model="data.city_id" placeholder="请选择区/县">
                <el-option v-for="item in city" :label="item.name" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="机型选择" prop="checkList">
        <el-checkbox-group v-model="data.checkList" @change="modelChange">
          <el-checkbox label="S2"></el-checkbox>
          <el-checkbox label="B50"></el-checkbox>
          <el-checkbox label="T7"></el-checkbox>
          <el-checkbox label="T8"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-row type="flex" justify="space-between" :gutter="20">
        <el-col :span="12">
          <el-form-item label="模板宽度" prop="width">
            <el-input v-model.number="data.width" placeholder="请输入模板宽度" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="模板高度" prop="height">
            <el-input v-model.number="data.height" placeholder="请输入模板高度" clearable></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-between" :gutter="20">
        <el-col :span="12">
          <el-form-item label="打印类型" prop="print_type">
            <el-select v-model="data.print_type+''" placeholder="请选择打印类型" style="width: 235px;">
              <el-option label="连续纸" value="1"></el-option>
              <el-option label="间隙纸" value="2"></el-option>
              <el-option label="黑标纸" value="3"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="旋转角度" prop="rotate">
            <el-select placeholder="请选择旋转角度" v-model="data.rotate">
              <el-option label="0度" value="0"></el-option>
              <el-option label="90度" value="90"></el-option>
              <el-option label="180度" value="180"></el-option>
              <el-option label="270度" value="270"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="模板图片" required>
        <el-upload limit="1" ref="upload" list-type="picture" :action="baseURL+'template/upload'" :on-preview="handlePreview" :on-remove="handleRemove"
                   :file-list="fileList" :on-success="uploadSuccess" :on-error="uploadError" :auto-upload="false" :headers="headers"
                   :before-upload="beforeAvatarUpload" name="img">
          <el-button slot="trigger" style="color: #333;border-color: #939393;">选择文件</el-button>
          <el-button style="margin-left: 10px;" type="success" @click="submitUpload"><i class="el-icon-upload"></i> 上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过1Mb</div>
        </el-upload>
      </el-form-item>

      <!--下面为动态项-->
      <div v-for="(item,index) in data.element">
        <el-form-item style="border-top: 1px solid #eee;text-align: right;">
          <el-button class="el-icon-delete" size="small" v-if="index!=0" @click="deleteElement(index)"></el-button>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="元素类型">
              <el-select placeholder="请选择元素类型" v-model="item.type" @change="selectChange">
                <el-option label="文本框" value="1"></el-option>
                <el-option label="线条" value="2"></el-option>
                <el-option label="一维码" value="3"></el-option>
                <el-option label="二维码" value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="item.type==1||item.type==4">
            <el-form-item label="元素名称" :prop="'element.'+index+'.name'" :rules="{required:true,trigger:'blur',message:'请输入元素名称'}">
              <!--<el-input placeholder="请输入元素名称" v-model="item.name"></el-input>-->
              <el-select placeholder="请选择元素名称" v-model="item.name" clearable>
                <el-option v-for="item in nameList" :value="item.name" :label="item.name" :key="item.name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12" v-if="item.type==1">
            <el-form-item label="字号" :prop="'element.'+index+'.font'" :rules="{required:true,trigger:'blur',message:'请输入字号'}">
              <el-input placeholder="请输入字号" v-model="item.font"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="宽度" :prop="'element.'+index+'.width'" :rules="{required: true, message: '请输入宽度', trigger: 'blur'}">
              <el-input placeholder="宽度" v-model="item.width"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="item.type==1">
            <el-form-item label="高度" :prop="'element.'+index+'.height'" :rules="{required: true, message: '请输入高度', trigger: 'blur'}">
              <el-input placeholder="高度" v-model="item.height"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="X坐标" :prop="'element.'+index+'.x'" :rules="{required: true, message: '请输入X坐标', trigger: 'blur'}">
              <el-input placeholder="X坐标" v-model="item.x"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Y坐标" :prop="'element.'+index+'.y'" :rules="{required: true, message: '请输入Y坐标', trigger: 'blur'}">
              <el-input placeholder="Y坐标" v-model="item.y"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="item.type==2">
            <el-form-item label="X2" :prop="'element.'+index+'.x2'" :rules="{required: true, message: '请输入X2坐标', trigger: 'blur'}">
              <el-input placeholder="X2" v-model="item.x2"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="item.type==2">
            <el-form-item label="Y2" :prop="'element.'+index+'.y2'" :rules="[{required: true, message: '请输入Y2坐标', trigger: 'blur'}]">
              <el-input placeholder="Y2" v-model="item.y2"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="item.type==1">
            <el-form-item label="对齐类型" :prop="'element.'+index+'.align'" :rules="{required: true, message: '请选择对齐类型', trigger: 'blur'}">
              <el-select placeholder="请选择元素类型" clearable v-model="item.align">
                <el-option label="左对齐" value="1"></el-option>
                <el-option label="右对齐" value="2"></el-option>
                <el-option label="居中对齐" value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="item.type==1">
            <el-form-item label="是否加粗">
              <el-checkbox :label="is_bold" v-model="item.is_bold" true-label=1 false-label=0></el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="item.type==3">
            <el-form-item label="条码高度" :prop="'element.'+index+'.height'" :rules="{required: true, message: '请输入条码高度', trigger: 'blur'}">
              <el-input placeholder="条码高" v-model="item.height"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <el-form-item style="text-align: right;margin-top: 30px;">
        <el-button type="success" @click="addElement">新增元素</el-button>
        <el-button type="success" @click="saveTemp">保存模板</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
  import {baseURL} from "../../utils/request";

  export default {
    props: {
      data: {
        type: Object,
        default: function () {
          return {}
        }
      },
      showHide: {
        type: Boolean
      }
    },
    data() {
      return {
        baseURL: baseURL,
        // 图片上传token
        headers: {
          Authorization: this.$Cookies.get('token')
        },
        fileList: [],
        province: [],
        city: [],
        form: {
          title: '',
          model: '',
          width: '',
          height: '',
          print_type: '',
          rotate: '',
          img: '',
          element: [{type: '1', is_bold: 0, x: 0, y: 0, x2: 0, y2: 0}],
          province_id: '',
          city_id: '',
          checkList: []
        },
        // 上传
        fileList: [],
        FormRules: {
          title: [{required: true, trigger: 'blur', message: '请输入模板名称'}],
          width: [{required: true, trigger: 'blur', message: '请输入宽度'}],
          height: [{required: true, trigger: 'blur', message: '请输入高度'}],
          print_type: [{required: true, trigger: 'change', message: '请选择打印类型'}],
          province_id: [{required: true, trigger: 'change', message: '请选择省份'}],
          city_id: [{required: true, trigger: 'change', message: '请选择区域'}],
          rotate: [{required: true, trigger: 'change', message: '请选择旋转角度'}],
          font: [{required: true, message: '请输入字号', trigger: 'blur'}],
          checkList: [{required: true, message: '请选择机型', trigger: 'change'}]
        },
        nameList: [ //元素名称
          {name: '品名'},
          {name: '产地'},
          {name: '计价单位'},
          {name: '建议零售价'},
          {name: '物价员'},
          {name: '生产年份'},
          {name: '期数'},
          {name: '香烟类型'},
          {name: '焦油量'},
          {name: '烟碱量'},
          {name: '一氧化碳'},
          {name: '烟长'},
          {name: '规格'},
          {name: '元/条'},
        ]

      }
    },
    methods: {
      //删除元素
      deleteElement(idx) {
        this.data.element.splice(idx, 1);
      },
      addElement() {   //新增元素
        this.data.element.push({type: '1',x: 0, y: 0, x2: 0, y2: 0});
      },
      onSubmit() {
        // console.log('submit!');
      },
      submitUpload() {
        this.$refs.upload.submit();
      },
      handleRemove(file, fileList) {
        // console.log(file, fileList);
      },
      handlePreview(file) {
        // console.log(file);
      },
      uploadSuccess(response, file, fileList) {
        if (response.code == 1) {
          this.$message.success('图片上传成功');
          this.data.img = response.data.url;
        } else {
          this.$message.error(response.msg)
        }
        // console.log(response.data.url);
      },
      uploadError(err, file, fileList) {
        this.$message.error(err);
      },
      //限制图片格式、尺寸
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 1;
        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 1MB!');
        }
        return isJPG && isLt2M;
      },
      //机型选择
      modelChange() {
        this.data.model = this.data.checkList.join();
      },
      // 保存模板、   还没做完  180519  by:jw
      saveTemp() {
        // console.log(this.form);
        this.$refs.formRef.validate(valid => {
          if (valid) {
            if (this.data.img == '') {
              this.$message.error('请上传模板图片');
              return;
            }
            this.$ajaxPost('/template/update', this.data).then(({data}) => {
              if (data.code == 1) {
                this.$message.success(data.msg);
                console.log(this.$parent.$parent);
                this.$parent.$parent.tempDialog = false;
                this.$parent.$parent.getTempList({limit: 15, page: 1});
              } else {
                this.$message.error(data.msg)
              }
              /*              if (data.code == 1) {
                              this.$alert(
                                `
                                        <div class="alert-success">
                                          <i class="el-icon-success"></i>
                                        <p class="tip-txt">模板保存成功，可在列表里查看</p>
                                        </div>
                                    `,
                                {
                                  dangerouslyUseHTMLString: true,
                                  showClose: false,
                                  confirmButtonText: '知道了',
                                  confirmButtonClass: 'niubi',
                                  customClass: 'custom-alert'
                                });
                              this.$refs.formRef.resetFields();
                              this.$refs.upload.clearFiles()
                            } else {
                              // console.log(data);
                              this.$message.error(data.msg)
                            }*/
            })
          }
        });
      },
      //获取省
      getProvince() {
        this.$ajaxGet('/system/get_district', {action: 'province', id: 0}).then(({data}) => {
          if (data.code == 1) {
            this.province = data.data.result;
          }
        })
      },
      //获取市
      getCity(val) {
        this.$ajaxGet('/system/get_district', {action: 'city', id: val || this.data.province_id}).then(({data}) => {
          this.city = data.data.result;
        })
      },
      //省改变
      provinceChange(val) {
        this.data.city_id = '';
        this.getCity(val);
      },
      //元素类型选择改变
      selectChange() {
      },
      /*      //获取元素名称
            getNameList() {
              this.$ajaxGet('goods/get_list', {limit: 999}).then(({data}) => {
                if (data.code == 1) {
                  data.data.result.forEach((item) => {
                    this.nameList.push({value: item.brand + item.name});
                  });
                  console.log(this.nameList);
                }
              })
            }*/
    },
    // 组件准备好后
    mounted() {
      this.getProvince();
      this.getCity();
      /*      console.log('新增模板页面button数据');
            console.log(this.$store.getters.page_buttons);*/
      console.log(this.data);
      this.data = Object.assign({}, this.data, {print_type: this.data.print_type + '', rotate: this.data.rotate + ''});
      let idx = this.data.img.lastIndexOf('/') + 1;
      this.fileList.push({name: this.data.name, url: this.data.url});
      // console.log(this.data.img.lastIndexOf('/'));
      /*     this.getNameList(); //获取元素名称*/
    },
    //路由离开时
    /*   beforeRouteLeave(to, from, next) {
         if (this.form.title != '') {
           next(false);
           this.$confirm(
             `
             <div class="alert-success">
               <i class="el-icon-warning"></i>
             <p class="tip-txt">模板尚未保存，确认要离开吗？</p>
             </div>
           `
             , {
               confirmButtonText: '继续编辑',
               cancelButtonText: '确认离开',
               dangerouslyUseHTMLString: true,
               showClose: false,
               closeOnClickModal: false,
               cancelButtonClass: 'btn-gray',
               customClass: 'custom-alert-warn',
               confirmButtonClass: 'btn-confirm'
             }).then(() => {
             this.$message({
               type: 'success',
               message: '继续编辑!'
             });
           }).catch(() => {
             next()
           });
         } else {
           next()
         }
       },*/
    watch: {
      'data.id': function (newVal, oldVal) {
        if (newVal) {
          this.fileList = [];
          this.fileList.push({name: this.data.name, url: this.data.url})
        }
      }
    }
  }
</script>
<style scoped lang="scss">
  #app .create-temp {
    .el-form-item {
      margin-bottom: 30px;
    }
    .el-select {
      width: 100%;
    }
    .el-button--success {
      background-color: #1aa86b;
      border-color: #1aa86b;
    }
    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #606266;
    }
    .temp-location {
      .el-form-item {
        float: left;
        width: 100%;
        margin-bottom: 0;
        &:first-child {
          /*margin-right: 20px;*/
        }
      }
    }
  }

</style>
<style lang="scss">

  /*alert成功弹窗样式*/
  .el-message-box__wrapper .custom-alert, .el-message-box__wrapper .custom-alert-warn {
    width: 400px;
    text-align: center;
    padding: 10px;
  }

  .alert-success .el-icon-success {
    font-size: 60px;
    color: #1aa86b;
  }

  .alert-success .tip-txt {
    margin-top: 20px;
    font-size: 16px;

  }

  .custom-alert .el-message-box__btns {
    margin-top: 20px;
    margin-bottom: 30px;
    text-align: center;
  }

  .custom-alert .el-message-box__btns .el-button {
    min-width: 100px;
    background-color: #1aa86b;
    border-color: #1aa86b;
    color: #fff;
    padding: 12px 20px;
  }

  /*离开页面*/
  .custom-alert-warn .el-icon-warning {
    font-size: 60px;
    color: #f4cf36;
  }

  .custom-alert-warn .el-message-box__btns .btn-gray {
    background-color: #aaa;
    border-color: #aaa;
    color: #fff;
  }

  .custom-alert-warn .btn-confirm {
    background-color: #1aa86b;
    border-color: #1aa86b;
  }

  .custom-alert-warn .el-message-box__btns {
    text-align: center;
    padding-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/temp/index.vue